import { Row, Col, Form, ButtonGroup, Button } from "react-bootstrap"
import { useState } from "react"
// import { useParams } from "react-router-dom"
import { useCallback, useEffect } from "react"
import { useSelector } from 'react-redux';
import AddNew from "./announcements/AddNew";
import AnnouncementCard from './announcements/AnnouncementCard';
import { canAccessAudience, isMemberEquivalent, isGuestAudienceEquivalent } from 'utils/acl';

export default function AnnouncementsCard() {
  const [selectedGroup, setSelectedGroup] = useState("");

  const url = process.env.REACT_APP_URL;
  // const meetingId = useParams().meetingId;

  const [announcements, setAnnouncements] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { user: authUser } = useSelector(x => x.auth);

  const getAnnouncements = useCallback(async () => {
    try {
      const response = await fetch(`${url}/announcements`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      setAnnouncements(data);
    } catch (e) {
      console.log(`Announcements component - Get Announcements error: ${e}`);
    }
  }, [url]);

  useEffect(() => {
    getAnnouncements();
  }, [getAnnouncements]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleGroupChange = (group) => {
    setSelectedGroup(group);
  };

  // Filter announcements based on user access level
  const filteredAnnouncements = announcements.filter((announcement) => {
    if (!authUser) {
      // If no authenticated user, show only public announcements
      return announcement.to === "Public";
    }
    if (!canAccessAudience(authUser.user.acl, announcement.to)) {
      return false;
    }
    return true;
  });

  // Further filter announcements based on search term
  const searchedAnnouncements = filteredAnnouncements.filter((announcement) => {
    const searchTermLower = searchTerm.toLowerCase();
    return (
      announcement.title.toLowerCase().includes(searchTermLower) ||
      (announcement.shortDescription && announcement.shortDescription.toLowerCase().includes(searchTermLower)) ||
      (announcement.description && announcement.description.toLowerCase().includes(searchTermLower))
    );
  });

  // Group announcements based on the selected group
  const groupedAnnouncements = selectedGroup
    ? searchedAnnouncements.filter((announcement) => announcement.to === selectedGroup)
    : searchedAnnouncements;

  return (
    <div className="announcements-tools-panel">
      <div className="announcements-tools-top">
        <div className="announcements-tools-meta">
          {groupedAnnouncements.length} announcement{groupedAnnouncements.length === 1 ? '' : 's'}
        </div>
      </div>

      <Row className="mb-2">
        {(authUser && authUser.user.acl === 'Officer') &&
          <Col xs={12} key={'newAnnouncement'}>
            <AddNew getAnnouncements={getAnnouncements} />
          </Col>
        }
      </Row>

      <Row className="mb-3">
        <Col xs={12}>
          <div className="announcements-search-shell">
            <i className="bi bi-search announcements-search-icon"></i>
            <Form.Control
              type="text"
              placeholder="Search announcements"
              value={searchTerm}
              onChange={handleSearchChange}
              className="announcements-search-input"
            />
          </div>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col xs={12} lg={12}>
          <ButtonGroup className="announcements-filter-group">
            {authUser.user.acl === "Officer" && (
              <Button
                className="announcements-filter-btn"
                onClick={() => handleGroupChange("Officer")}
                active={selectedGroup === "Officer"}
              >
                Officers
              </Button>
            )}
            {isMemberEquivalent(authUser.user.acl) && (
              <Button
                className="announcements-filter-btn"
                onClick={() => handleGroupChange("Member")}
                active={selectedGroup === "Member"}
              >
                Members
              </Button>
            )}
            {isGuestAudienceEquivalent(authUser.user.acl) && (
              <Button
                className="announcements-filter-btn"
                onClick={() => handleGroupChange("Guest")}
                active={selectedGroup === "Guest"}
              >
                Guests
              </Button>
            )}
            <Button
              className="announcements-filter-btn"
              onClick={() => handleGroupChange("Public")}
              active={selectedGroup === "Public"}
            >
              Public
            </Button>
            <Button
              className="announcements-filter-btn announcements-filter-btn--all"
              onClick={() => handleGroupChange("")}
              active={selectedGroup === ""}
            >
              All
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      <Row className="announcements-list-row">
        {groupedAnnouncements.length > 0 ? (
          groupedAnnouncements.map((announcement) => (
            <Col xs={12} key={announcement._id} className="mb-2">
              <AnnouncementCard
                announcement={announcement}
                getAnnouncements={getAnnouncements}
              />
            </Col>
          ))) :
          <Col xs={12}>
            <div className="announcements-empty-state">No announcements found.</div>
          </Col>
        }
      </Row>

    </div>
  )
}